import "./App.css";
import Login from "./pages/Login";

function App() {
  return (
    <div className="App" style={{ background: "#F5F6FA", height: "100vh" }}>
      <Login />
    </div>
  );
}

export default App;
